import api from '../api';

export const forgotPasswordsService = async (email: string): Promise<void> => {
  await api.post('/passwords/forgot', { email });
};
